import type { ReactNode } from "react";

import { Stack, Typography } from "@braintrust/braintrust-ui-components";

type DetailsContentContainerProps = { children: ReactNode };

export const DetailsContentContainer = ({
  children,
}: DetailsContentContainerProps) => {
  return (
    <Stack direction="row" divider={<Separator />} sx={{ gap: 0.5 }}>
      {children}
    </Stack>
  );
};

const Separator = () => {
  return (
    <Typography
      component="span"
      variant="paragraph"
      size="small"
      color="tertiary"
    >
      ·
    </Typography>
  );
};
